import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import { DownOutlined } from '@ant-design/icons';
import SessionStorage from '@vantiva-sa/homesight_humaui/Utilities/SessionStorage';
import { AppStorageKeys } from '@vantiva-sa/homesight_humaui/Utilities/Constants';
import { Dropdown, Space, Button, message } from 'antd';
import { DownloadData } from '../Common/Icons';
import { apiCallback } from '@vantiva-sa/homesight_humaui/Services/Common';

const ENV_VARS = SessionStorage.get(AppStorageKeys.envVars);

const DataExport = () => {
  const trans = useSelector(translator);
  const providerBulkDataApi = useSelector((state) => state.apis.providerBulkDataApi);
  const [dataExports, setDataExports] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [loadingMonths, setLoadingMonths] = useState(true);
  const [downloading, setDownloading] = useState(false);
  const [downloadUrl, setDownloadUrl] = useState(null);
  const [downloadFilename, setDownloadFilename] = useState(null);

  useEffect(() => {
    if (providerBulkDataApi) {
      fetchAllExportMonths();
    }
  }, [providerBulkDataApi]);

  const fetchAllExportMonths = () => {
    setLoadingMonths(true);
    providerBulkDataApi.getProviderBulkDataMonthly(
      {},
      apiCallback({
        translator: trans,
        successCallback: (data) => {
          setDataExports(data?.months || []);
          setLoadingMonths(false);
        },
        errorCallback: (err) => {
          console.error('Error fetching months:', err);
          setLoadingMonths(false);
        },
      })
    );
  };

  const handleMenuClick = (e) => {
    if (e.key === selectedMonth) return; // Prevent re-fetching for the same month

    setSelectedMonth(e.key);
    setDownloadUrl(null); // Reset only when month changes
    setDownloadFilename(null);
    setDownloading(true);

    providerBulkDataApi.getProviderBulkDataMonthly(
      { month: e.key },
      apiCallback({
        translator: trans,
        successCallback: (data) => {
          const file = data?.files?.[0]; // Get the first file
          if (file?.url && file?.filename) {
            setDownloadUrl(file.url);
            setDownloadFilename(file.filename);
          } else {
            // message.error("Download URL not available.");
            console.error('Download URL not available.');
          }
          setDownloading(false);
        },
        errorCallback: (err) => {
          console.error('Failed to prepare download:', err);
          // message.error("Failed to prepare download.");
          setDownloading(false);
        },
      })
    );
  };

  const handleDownload = () => {
    if (!downloadUrl || !downloadFilename) {
      // message.warning("Download URL is not ready.");
      console.warn('Download URL is not ready.');
      return;
    }

    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = downloadFilename;
    link.click();
    link.remove();

    // setDownloading(true);

    // fetch(downloadUrl, { mode: "no-cors" })
    //   .then((response) => {
    //     if (!response.ok) throw new Error("Network response was not ok.");
    //     return response.blob();
    //   })
    //   .then((blob) => {
    //     const url = window.URL.createObjectURL(blob);
    //     const link = document.createElement("a");
    //     link.style.display = "none";
    //     link.href = downloadUrl;
    //     link.download = downloadFilename;
    //     document.body.appendChild(link);
    //     link.click();
    //     window.URL.revokeObjectURL(url);
    //     link.parentNode.removeChild(link);
    //     setDownloading(false);
    //   })
    //   .catch((error) => {
    //     console.error("Download failed:", error);
    //     message.error("Failed to download file.");
    //     setDownloading(false);
    //   });
  };

  const formatMonthLabel = (monthStr) => {
    try {
      const [year, month] = monthStr.split('-');
      const date = new Date(year, month - 1);
      const translatedMonth = trans(
        String(date.toLocaleString('default', { month: 'long' })).toUpperCase()
      );
      return `${translatedMonth} ${year}`;
    } catch {
      return monthStr;
    }
  };

  const items = dataExports.map((month) => ({
    label: formatMonthLabel(month),
    key: month,
  }));

  return (
    <>
      <div className="help-page-card-header">{trans('DATAEXPORT')}</div>
      <div className="help-page-card-information">
        <span className="help-page-download-label">{trans('SELECTTHEMONTHYOUWANTTOEXPORT')}</span>
        <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
          <Dropdown
            overlayClassName="select-month-download"
            menu={{ items, onClick: handleMenuClick }}
            trigger={['click']}
            disabled={loadingMonths}
          >
            <Button className="data-export-dropdown" disabled={loadingMonths}>
              <Space>
                {selectedMonth ? formatMonthLabel(selectedMonth) : trans('SELECTAMONTH')}
                <DownOutlined />
              </Space>
            </Button>
          </Dropdown>

          <div
            onClick={downloadUrl && !downloading ? handleDownload : undefined}
            style={{
              cursor: downloadUrl && !downloading ? 'pointer' : 'not-allowed',
              opacity: downloadUrl && !downloading ? 1 : 0.5,
            }}
          >
            <DownloadData />
          </div>
        </div>
      </div>
    </>
  );
};

export default DataExport;
